import styled from '@emotion/styled'

import { breakpoints, spacing } from 'main/ui'

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
`

export const FieldGroupContainer = styled.div`
  display: flex;
  flex-direction: column;

  > * {
    flex-basis: 0;
    flex-grow: 1;
    min-width: 0;
  }

  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(2)}px;
  }

  @media (min-width: ${breakpoints.lg}px) {
    flex-direction: row;

    > :not(:last-child) {
      margin-bottom: 0;
      margin-right: ${spacing.majorScale(2)}px;
    }
  }
`
